






























import { FileHandler } from '@/helpers/fileManager';
import { convertMarkdownToHTML, globalState, IGlobalState } from '@/shared';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { IOutline } from './Editor.vue';

@Component({
  components: {
    // EditorContent
  },
})
export default class SideNav extends Vue {
  outline: IOutline[] = [];

  globalState: IGlobalState = globalState;

  @Watch('globalState.editorContentHtml')
  onChildChanged() {
    setTimeout(() => {
      this.updateOutline();
    }, 100);
  }

  async openFileDialog() {
    const text = await FileHandler.openFileDialog();
    if (text) {
      globalState.editorContentHtml = convertMarkdownToHTML(text);
      globalState.isEmpty = this.globalState.editorContentHtml.length < 8;
    }
  }

  private updateOutline() {
    const json = this.globalState.editor.getJSON();
    this.outline = this.getOutline(json);
    this.setBoldHeader();
  }

  private getOutline(json: any): IOutline[] {
    return json?.content
      ?.filter((el: any) => el?.type === 'heading')
      .map((el: any) => ({ text: el?.content?.[0]?.text, level: el?.attrs?.level }));
  }

  beforeMount() {
    setTimeout(() => {
      this.handleScrollBolder();
      this.updateOutline();
      setTimeout(() => {
        this.setBoldHeader();
      }, 100);
    }, 100);
  }

  private handleScrollBolder() {
    const el = document.getElementById('tiptap-editor')?.getElementsByClassName('el-tiptap-editor__content')[0];
    let timeout: number;
    el?.addEventListener('scroll', () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        this.setBoldHeader();
      }, 100);
    });
  }

  private setBoldHeader() {
    const firstHeaderInViewportIndex = this.outline.findIndex((o) => {
      const elMatched = [...document.querySelectorAll('h' + o.level)].filter((a) => a?.textContent?.includes(o.text))[0];
      return elMatched ? this.isElementInViewport(elMatched) : 0;
    });

    const ref = (this.$refs[Math.max(firstHeaderInViewportIndex - 1, 0)] as HTMLElement[])?.[0];
    if (ref) {
      Object.values(this.$refs).forEach((a: any) => (a[0] ? (a[0].style.fontWeight = 'normal') : null));
      ref.style.fontWeight = 'bold';
    }
  }

  isElementInViewport(el: Element) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) /* or $(window).height() */ &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
    );
  }

  onHeaderClick(outline: IOutline) {
    const elMatched = [...document.querySelectorAll('h' + outline.level)].filter((a) => a?.textContent?.includes(outline.text));
    elMatched[0].scrollIntoView({ behavior: 'smooth' });
  }
}
